module.exports = __webpack_public_path__ + "img/step_3.ecc6e9d1.png";